const APP_MAIN_PAGE = "/assets";
const OPPORTUNITIES_PATH = "/opportunities";
const QUOTES_PATH = "/quotes";
const DOCUMENTS_PATH = "/documents";
const DOCSTEMPLATE_PATH = "/template";

const PAGES = {
  PIPELINE: {
    name: "Pipeline",
    title: "Pipeline | Revv",
  },
  TEMPLATES: {
    name: "Templates",
    title: "Templates | Revv",
  },
  DASHBOARD: {
    name: "Dashboard",
    title: "Dashboard | Revv",
  },
  PRODUCTS: {
    name: "Products",
    title: "Products | Revv",
  },
  PRICEBOOKS: {
    name: "Pricebooks",
    title: "Pricebooks | Revv",
  },
  ASSETS: {
    name: "Documents",
    title: "Documents | Revv",
  },
  WORKFLOWS: {
    name: "Workflows",
    title: "Workflows | Revv",
  },
  INBOX: {
    name: "Inbox",
    title: "Inbox | Revv",
  },
};

export {
  APP_MAIN_PAGE,
  DOCUMENTS_PATH,
  DOCSTEMPLATE_PATH,
  OPPORTUNITIES_PATH,
  QUOTES_PATH,
  PAGES,
};



// WEBPACK FOOTER //
// ./src/constants/paths.js